document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('variant-change-dropdown')) return;

  const select = e.target;
  const newVariantId = select.value;
  const line = select.dataset.line;

  if (!newVariantId || !line) return;

  const cartItem = select.closest('li');
  cartItem?.classList.add('loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: Number(line),
      quantity: 0
    })
  })
  .then(() => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: newVariantId,
        quantity: 1
      })
    });
  })
  .then(() => {
    return fetch('/?section_id=mini-cart');
  })
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newMiniCart = doc.querySelector('mini-cart');
    const currentMiniCart = document.querySelector('mini-cart');

    if (newMiniCart && currentMiniCart) {
      currentMiniCart.innerHTML = newMiniCart.innerHTML;
    }
  })
  .catch(err => console.error('Variant swap error:', err));
});


//-----------------------

$(document).ready(function(){

  var slider = $('.cstm_product_slider');

  slider.slick({
    dots:false,
    arrows:true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>', 
    nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    slidesToShow:4,
    slidesToScroll:1,
    responsive:[
      {
        breakpoint:1024,
        settings:{ slidesToShow:3 }
      },
      {
        breakpoint:750,
        settings:{
          slidesToShow:1,
          centerMode:true,
          centerPadding:'120px'
        }
      }
    ]
  });

  // 👇 Image area par swipe kare to card slider disable
  $(document).on('mouseenter touchstart', '.product-media-wrapper', function(){
    slider.slick('slickSetOption','swipe', false, true);
  });

  // 👇 Image area se bahar aaye to card slider enable
  $(document).on('mouseleave touchend', '.product-media-wrapper', function(){
    slider.slick('slickSetOption','swipe', true, true);
  });

});
